export const INVALID_NAME_ERROR_MESSAGE =
  'Only English letters, apostrophes, hyphens, commas, periods and spaces are allowed. At least one letter is required.';
